import React, { useState } from "react";
import PropTypes from "prop-types";
import { AnimatePresence } from "framer-motion";
import { Maximize2, Minimize2 } from "lucide-react";
import Tooltip from "./Tooltip";
import Button from "./Button";
import { cn } from "../../utils/classNames";

const DensityToggle = ({ density, onChange, className }) => {
  const [hoveredDensity, setHoveredDensity] = useState(null);
  const [anchorElement, setAnchorElement] = useState(null);

  if (!onChange) return null;

  const densities = [
    { value: "comfortable", icon: Maximize2, label: "Comfortable" },
    { value: "compact", icon: Minimize2, label: "Compact" },
  ];

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 p-1",
        "bg-card border border-accent-gold/70 rounded-md",
        className
      )}
    >
      {densities.map(({ value, icon: Icon, label }) => {
        return (
          <div
            key={value}
            className="relative"
            onMouseEnter={(e) => {
              setHoveredDensity(value);
              setAnchorElement(e.currentTarget.querySelector('button'));
            }}
            onMouseLeave={() => {
              setHoveredDensity(null);
              setAnchorElement(null);
            }}
          >
            <Button
              type="button"
              size="icon"
              variant={density === value ? "filter-active" : "filter"}
              onClick={() => onChange(value)}
              className="h-11 w-11"
              aria-label={`${label} density`}
              aria-pressed={density === value}
            >
              <Icon className="h-4 w-4" />
            </Button>
            <AnimatePresence>
              {hoveredDensity === value && anchorElement && (
                <Tooltip
                  position="bottom"
                  className="max-w-[240px] px-3 py-2"
                  contentClassName="text-caption"
                  anchorRef={{ current: anchorElement }}
                  onClose={() => setHoveredDensity(null)}
                >
                  {label}
                </Tooltip>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};

DensityToggle.propTypes = {
  density: PropTypes.oneOf(["comfortable", "compact"]).isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default DensityToggle;
